import {Injectable} from '@angular/core';
import {PushEventService} from '@app/services/push-event/push-event.service';
import {checkResponse} from '@app/shared/utils/app-utils';
import {QueueControlService, Skill} from '@gt-api';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, mapTo, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GtQueueService {
  private agentStates = new Map<string, BehaviorSubject<boolean>>();

  constructor(private queueService: QueueControlService, private pushEventService: PushEventService) {
    this.subscribePush();
  }

  private subscribePush(): void {
    const ps = this.pushEventService.pushSubjects;

    ps.AgentStateTransition.subscribe(astEvent => {
      const loggedIn = astEvent.new_state > 0;
      if (this.agentStates.has(astEvent.agent_login)) {
        this.agentStates.get(astEvent.agent_login).next(loggedIn);
      } else {
        this.agentStates.set(astEvent.agent_login, new BehaviorSubject<boolean>(loggedIn));
      }
    });
  }

  getAgentState(oname: string, login: string): Observable<boolean> {
    if (!this.agentStates.has(login)) {
      this.agentStates.set(login, new BehaviorSubject<boolean>(false));
      this.fetchAgentState(oname, login).subscribe();
    }
    return this.agentStates.get(login).asObservable();
  }

  fetchAgentState(oname: string, login: string): Observable<number> {
    return this.queueService.getAgentState1(oname, login).pipe(
      checkResponse(),
      map(r => r.agentState.status),
      tap(s => this.agentStates.get(login).next(s > 0))
    );
  }

  logoutAgent(oname: string, login: string): Observable<void> {
    return this.queueService.logoutAgent1(oname, login).pipe(checkResponse(), mapTo(void 0));
  }

  loginAgent(oname: string, login: string): Observable<void> {
    return this.queueService.loginAgent1(oname, login).pipe(checkResponse(), mapTo(void 0));
  }

  getSkills(oname: string, login: string): Observable<Array<Skill>> {
    return this.queueService.getSkills1(oname, login).pipe(map(res => res.skills));
  }

  addSkill(oname: string, login: string, skill: Skill): Observable<void> {
    return this.queueService.addSkill1(oname, login, skill).pipe(checkResponse(), mapTo(void 0));
  }

  editSkill(oname: string, login: string, skill: Skill): Observable<void> {
    return this.queueService.editSkill1(oname, login, skill).pipe(checkResponse(), mapTo(void 0));
  }

  removeSkill(oname: string, login: string, skill: Skill): Observable<void> {
    return this.queueService.removeSkill1(oname, login, skill).pipe(checkResponse(), mapTo(void 0));
  }
}
